$(document).ready(function () {

    $(".register-btn").click(function () {
        event.preventDefault();

        var honeypot = $('#honeypot').val();

        if(!honeypot){

            $('.authorization .required').each(inputCheck);

            if($('.error').length == 0){

                loader_on();

                // Получаем данные с формы
                var $register_phone                     = $("#register_phone").val(),
                    $register_email                     = $("#register_email").val(),
                    $register_pass                      = $("#register_pass").val(),
                    $register_pass_confirm              = $("#register_pass_confirm").val(),
                    $first_name                         = $("#first_name").val(),
                    $last_name                          = $("#last_name").val(),
                    $register_terms_of_agreement        = $("#register_terms_of_agreement").prop('checked');               
    
                $.post('/wp-admin/admin-ajax.php', {
                    action: 'register_check_dashboard',
                    register_phone: $register_phone,
                    register_email: $register_email,
                    register_pass: $register_pass,
                    register_pass_confirm: $register_pass_confirm,
                    first_name: $first_name,
                    last_name: $last_name,
                    register_terms_of_agreement: $register_terms_of_agreement
                },
                    function (res) {

                        loader_off();
    
                        var $json = JSON.parse(res);                        
                        
                        if($json.result == 'success'){

                            /*

                            // Отправляем SMS код на номер телефона
                            $.post('/wp-admin/admin-ajax.php', {
                                action: 'send_sms_code',
                                data: $json.check,
                                // contentType:"application/x-javascript; charset:ISO-8859-1"
                            },
                                function (res) {

                                    var timerBlock = $('#code-timer');
                                    var num = 120; //количество секунд
                                    var $jsonSMS = JSON.parse(res);                         
                                    
                                    if($jsonSMS.result == 'success'){    

                                        $('.code-input').on('keyup', function(){
                                            var val  = $(this).val(),
                                                code = $jsonSMS.code;
                                
                                            if( val.indexOf('_') < 0 ){
                                                
                                                if( val == code ){

                                                    $('.loading').fadeIn(300);
                                                    $('.code-input').attr('disabled', 'disabled');

                                                    */

                                                    $.post('/wp-admin/admin-ajax.php', {
                                                        action: 'register_dashboard',
                                                        data: $json.check,
                                                    },
                                                        function (res) {

                                                            var $json = JSON.parse(res);
                                                            
                                                            if($json.result == 'success'){ 
                                                                // При Регистрации кидаем пользователя в личный кабинет
                                                                // При Регистрации обновляем страницу
                                                                location.reload();

                                                            }else{
                                                                $('.preloader').fadeOut(300); 
                                                                returnErrors($json.text_error);
                                                                
                                                                if($json.text_error.errors){
                                                                    var alert = $('.alert');
                                                                    alert.addClass('error');
                                                                    alert.find('.content .icon').addClass("icon-close");
                                                                    alert.find('.content .message').html('').append("<h4>Ошибка</h4><p>" + $json.text_error.errors + "</p>"); 
                                                                    alert.slideDown(200);
                                                                }           
                                                            }
                                                        }
                                                        
                                                    );

                                                    /*

                                                }else{
                                                    $('.confirm-code').addClass('code-invalid');
                                                    $('.code-input').removeAttr('disabled');
                                                }

                                            }
                                
                                        })

                                    }else{
                                        num = num - $jsonSMS.delay;                        
                                    }

                                    $(".button-register, .terms_of_agreement_wrapper, .exist").hide();
                                    $(".confirm-code").fadeIn(300);

                                    $('.code-timer').removeClass('available');

                                    timerBlock.html(num);
                        
                                    var index = num;
                                    var timerId = setInterval(function() {
                                    timerBlock.html(--index);
                                    }, 1000);
                                
                                    setTimeout(function() {
                                    clearInterval(timerId);
                                        $('.code-timer').addClass('available');
                                    }, num*1000);
                                    
                                }
                                
                            );

                            */
    
                        }else{
                            console.log($json.text_error);
                            displayErrors($json.text_error);
                        }
                    }
                    
                );
    
            }
            
        }

    });

});
